import React, { createContext, useContext, useState, ReactNode } from "react";

export type BreadcrumbsItem = {
  title: string | ReactNode;
  href?: string;
};

type BreadcrumbsContextType = {
  breadcrumbs: BreadcrumbsItem[];
  setBreadcrumbs: (items: BreadcrumbsItem[]) => void;
};

const BreadcrumbsContext = createContext<BreadcrumbsContextType | undefined>(
  undefined,
);

export const useBreadcrumbs = (): BreadcrumbsContextType => {
  const context = useContext(BreadcrumbsContext);
  if (!context) {
    throw new Error("useBreadcrumbs must be used within BreadcrumbsProvider");
  }
  return context;
};

export const BreadcrumbsProvider = ({ children }: { children: ReactNode }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsItem[]>([]);
  return (
    <BreadcrumbsContext value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext>
  );
};
